"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUY_SELL_LAYOUTS = void 0;
var BUY_SELL_LAYOUTS = exports.BUY_SELL_LAYOUTS = {
  PRICE_PER_UNIT: 'PRICE_PER_UNIT',
  AMOUNT_FOR_PRICE: 'AMOUNT_FOR_PRICE'
};